import store from "../redux/store";
import { CALENDAR_MANAGEMENT_KEY } from "../services-logic/calendar-management/calendar-management-logic";
import { COMPANY_DIRECTORY_KEY } from "../services-logic/company-directory/company-directory-logic";
import { KNOWLEDGE_BASE_KEY } from "../services-logic/knowledge-base/knowledge-base-logic";

export const getAllowedFeatures = () => {
  const accountTypeConfiguration = store.getState().info?.account?.accountTypeConfiguration;
  if (!accountTypeConfiguration) return [];
  return accountTypeConfiguration.features.filter(
    (feature) =>
      feature.id === COMPANY_DIRECTORY_KEY ||
      feature.id === CALENDAR_MANAGEMENT_KEY ||
      feature.id === KNOWLEDGE_BASE_KEY
  );
};

export const isServiceAllowed = (service) => {
  const accountTypeConfiguration = store.getState().info?.account?.accountTypeConfiguration;
  if (!accountTypeConfiguration) return false;
  const isExists = accountTypeConfiguration.features?.find((feature) => feature.id === service);
  return isExists !== undefined;
};

export const getServiceConfig = (service) => {
  const accountTypeConfiguration = store.getState().info?.account?.accountTypeConfiguration;
  if (!accountTypeConfiguration) return null;

  const serviceConfig = accountTypeConfiguration.features.find((feature) => feature.id === service);
  if (!serviceConfig) return null;
  return serviceConfig.config;
};
